import type { JSX } from "react";

/** Open string type — any marketplace slug is valid (shopee/lazada/tiktok/blibli/…). */
export type Marketplace = string;

const LABEL: Record<string, string> = {
  shopee: "Shopee",
  lazada: "Lazada",
  tiktok: "TikTok",
};

function toLabel(marketplace: string): string {
  return LABEL[marketplace] ?? marketplace.charAt(0).toUpperCase() + marketplace.slice(1);
}

export function MarketplaceChip({ marketplace }: { marketplace: string }): JSX.Element {
  return (
    <span
      data-testid="mkp-chip"
      data-mkp={marketplace}
      className="inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold"
      style={{
        background: `var(--mkp-${marketplace}-bg)`,
        color: `var(--mkp-${marketplace}-fg)`,
      }}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current" aria-hidden />
      {toLabel(marketplace)}
    </span>
  );
}
